import React from "react";
import {useHistory} from "react-router-dom";

export default function NsBtnBack({
                                    tipoClasse = "btn-card"
                                  }) {

    const history = useHistory();

    return (
        <button type={"button"} className={`btn ${tipoClasse}`} onClick={() => {
            history.goBack();
        }}>
            <i className="fas fa-angle-left"/> Indietro
        </button>
    )
}